import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-git3-icon',
  templateUrl: './code-git3.component.html'
})
export class CodeGit3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
